export function videoSubscriptions() {
    $(".product-list ul").slick({
        infinite: true,
        speed: 300,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        prevArrow: $(".product-list .common-slider-controls .prev-arrow"),
        nextArrow: $(".product-list .common-slider-controls .next-arrow"),
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                }
            },
        ]
    });

    let $holder_facilitator = $('.holder-facilitator');
    $holder_facilitator.find('.link, .avatar, .h3').hover(function () {
        $holder_facilitator.addClass('hover');
    }, function () {
        $holder_facilitator.removeClass('hover');
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/video-subscriptions.js